import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AxiosInstance from "../../utils/axiosInstance";
import toast from "react-hot-toast";

const MeetingAndAttandanceModel = ({ show, onClose }) => {
  const [uploadData, setUploadData] = useState({
    name: "",
    type: "meeting",
    file: null,
    user_type: "WAH",
  });

  const [errors, setErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);

  const docTypeOptions = [
    { label: "Meeting", value: "meeting" },
    { label: "Attendance", value: "attendance" },
    { label: "CUFS", value: "cufs" },
    { label: "DBE plans", value: "dbe" },
    { label: "Economic Reports", value: "economic_reports" },
  ];

  const docTypeOptions2 = [
    { label: "CUFS", value: "cufs" },
    { label: "DBE plans", value: "dbe" },

  ];
  const userTypeOptions = [
    { label: "WAH USER", value: "WAH" },
    { label: "MRB USER", value: "MRB" },
  ];

  const handleSubmit = async () => {
    const newErrors = {};
    const maxFileSize = 5 * 1024 * 1024;
    const allowedExtensions = ["pdf", "doc", "docx", "xlsx", "jpg", "png"];

    if (!uploadData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!uploadData.file) {
      newErrors.file = "Please select a file.";
    } else {
      const file = uploadData.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (file.size === 0) {
        newErrors.file = "This file is empty.";
      } else if (file.size > maxFileSize) {
        newErrors.file = "File must be 5MB or less.";
      } else if (!allowedExtensions.includes(fileExtension)) {
        newErrors.file = `Invalid file type. Allowed: ${allowedExtensions.join(
          ", "
        )}`;
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true);

      const response = await AxiosInstance.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_ADD_MEETING_AND_ATTANDANCE_FILE}`,
        {
          name: uploadData.name,
          doc_type: uploadData.type,
          user_type: uploadData.user_type,
        }
      );

      if (response?.data?.meeting_attendence_id) {
        const meeting_attendence_id = response.data.meeting_attendence_id;

        const formData = new FormData();
        formData.append("file", uploadData.file);
        formData.append("meeting_attendence_id", meeting_attendence_id);

        const fileUploadResponse = await AxiosInstance.post(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_UPLOAD_MEETING_AND_ATTANDANCE_FILE}`,
          formData
        );

        if (fileUploadResponse?.data) {
          toast.success("File uploaded successfully!");
          setUploadData({ name: "", type: "meeting", file: null });
          setErrors({});
          onClose(); // Close modal
        } else {
          toast.error("File upload failed!");
        }
      } else {
        toast.error("Failed to create document record.");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error(error?.response?.data?.message || "Error submitting data.");
    } finally {
      setShowLoader(false);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Upload {uploadData.type === "meeting" ? "Meeting" : "Attendance"}{" "}
              File
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={showLoader}
            />
          </div>
          <div className="modal-body">
            {/* Document Type Selector */}
            <div className="mb-3">
              <label className="form-label">User Type</label>
              <select
                className="form-select"
                value={uploadData.type}
                onChange={(e) =>
                  setUploadData({ ...uploadData, user_type: e.target.value })
                }
              >
                {userTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Document Type</label>
              <select
                className="form-select"
                value={uploadData.type}
                onChange={(e) =>
                  setUploadData({ ...uploadData, type: e.target.value })
                }
              >
                {uploadData.user_type == "WAH" &&
                  docTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}

                {uploadData.user_type == "MRB" &&
                  docTypeOptions2.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
              </select>
            </div>

            {/* Name Field */}
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={uploadData.name}
                onChange={(e) =>
                  setUploadData({ ...uploadData, name: e.target.value })
                }
              />
              {errors.name && <div className="text-danger">{errors.name}</div>}
            </div>

            {/* File Field */}
            <div className="mb-3">
              <label className="form-label">File</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) =>
                  setUploadData({ ...uploadData, file: e.target.files[0] })
                }
              />
              <small className="text-muted">
                Accepted file types:{" "}
                <strong>PDF, DOC, DOCX, XLSX, JPG, PNG</strong>. Max size:{" "}
                <strong>5MB</strong>.
              </small>
              {errors.file && <div className="text-danger">{errors.file}</div>}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={showLoader}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center justify-content-center"
              onClick={handleSubmit}
              disabled={showLoader}
              style={{ minWidth: "120px", height: "45px" }}
            >
              {showLoader ? (
                <span className="d-flex align-items-center">
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Uploading...
                </span>
              ) : (
                "Upload"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingAndAttandanceModel;
